import {createReducer, on} from '@ngrx/store';
import {
  ProductComponentModel,
  ProductType,
  Specification,
  SpecificationMap,
  Variant,
} from '../../data/model';
import * as addOnActions from '../add-on.actions';

export const addOnKey = 'add-ons';

export interface AddOnState {
  addOns: ProductComponentModel<ProductType>[];
  currentIndex: number;
  specs: {[id: string]: Specification[]} | undefined;
  addonLoadingComplete: boolean;
  variants: {[productId: string]: Variant[]} | undefined;
}

export const initialState: AddOnState = {
  addOns: [],
  currentIndex: 0,
  specs: undefined,
  addonLoadingComplete: false,
  variants: undefined,
};

export const reducer = createReducer(
  initialState,
  on(addOnActions.loadAddOnsSuccess, (state, {addOns}) => ({
    ...state,
    addOns: [...addOns],
    addonLoadingComplete: true,
  })),

  on(addOnActions.nextAddOn, state => {
    const result = {...state};
    result.currentIndex++;
    return result;
  }),

  on(addOnActions.previousAddOn, state => {
    const result = {...state};
    result.currentIndex--;
    return result;
  }),

  on(addOnActions.loadAddOnsFailure, addOnActions.loadAddOns, state => state),

  on(addOnActions.loadSpecs, state => ({
    ...state,
  })),

  on(addOnActions.loadSpecsSuccess, (state, {specs, productId}) => ({
    ...state,
    specs: {
      ...state.specs,
      [productId]: specs || [],
    },
  })),

  on(addOnActions.loadAddOns, state => ({
    ...state,
    addonLoadingComplete: false,
  })),

  on(addOnActions.loadAddOnsFailure, state => ({
    ...state,
    addonLoadingComplete: true,
  })),

  on(addOnActions.loadAddonSuccess, (state, {addon}) => ({
    ...state,
    addOns: state.addOns ? [...state.addOns, addon] : [addon],
  })),

  on(addOnActions.loadVariants, state => ({
    ...state,
  })),

  on(addOnActions.loadVariantsSuccess, (state, {variants, productId}) => ({
    ...state,
    variants: {
      ...state.variants,
      [productId]: [...variants],
    },
  })),
);

export const getAddOns = (
  state: AddOnState,
): ProductComponentModel<ProductType>[] => state.addOns;
export const getCurrentIndex = (state: AddOnState): number =>
  state.currentIndex;
export const getSpecs = (state: AddOnState): SpecificationMap | undefined =>
  state.specs;
export const getAddonLoadingComplete = (state: AddOnState): boolean =>
  state.addonLoadingComplete;
export const getVariants = (
  state: AddOnState,
): {[productId: string]: Variant[]} | undefined => state.variants;
